<template>
  <div class="DataTable">
    <!-- <v-toolbar flat color="white">
      <v-layout row wrap>
        <v-flex xs3>
          <v-text-field
              v-model="search"
              append-icon="search"
              label="Pretraga"
              xs5
              hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-toolbar>-->
    <v-layout column>
      <v-flex style="overflow: auto">
        <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          class="elevation-1"
          :pagination.sync="pagination"
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : '',
                  header.align === 'left'
                    ? 'text-xs-left'
                    : header.align === 'right'
                    ? 'text-xs-right'
                    : 'text-xs-center',
                ]"
                @click="changeSort(header.value)"
              >
                <v-icon small v-if="header.sortable !== false"
                  >arrow_upward</v-icon
                >
                {{ header.text }}
              </th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <tr>
              <td style="text-align: left">
                {{
                  items
                    .map(function (x) {
                      return x.id;
                    })
                    .indexOf(props.item.id) + 1
                }}
              </td>
              <td
                @click="props.expanded = !props.expanded"
                style="text-align: left"
              >
                {{ formatDateTime(props.item.date) }}
              </td>
              <td
                @click="props.expanded = !props.expanded"
                style="text-align: left"
              >
                {{ props.item.company.name }}
              </td>
              <td
                @click="props.expanded = !props.expanded"
                style="text-align: right"
              >
                {{ odrediVrednost(props.item.vineyardGrapeSellingItems) }} RSD
              </td>
              <td
                @click="props.expanded = !props.expanded"
                style="text-align: left"
              >
                {{ props.item.description }}
              </td>

              <td class="DataTable__ButtonHolder">
                <img
                  class="DataTable__Button"
                  title="Izmena"
                  src="../assets/icons/zatabele/ico-edit2.svg"
                  alt="ulaz-grozdja"
                  @click="editItem(props.item)"
                />
                <img
                  class="DataTable__Button"
                  title="Izbor sorte groŽđa"
                  src="../assets/icons/zatabele/ico-add.svg"
                  alt="delete-item"
                  @click="otvoriDialog(props.item)"
                />
                <img
                  class="DataTable__Button"
                  title="Brisanje"
                  src="../assets/icons/zatabele/ico-delete2.svg"
                  alt="delete-item"
                  @click="deleteItem(props.item)"
                />
              </td>
            </tr>
          </template>
          <template slot="expand" slot-scope="props">
            <table class="topics">
              <tr
                style="
                  border-bottom: solid;
                  border-width: 1px;
                  border-color: grey;
                "
              >
                <th style="text-align: center">{{ strSorta }}</th>
                <th style="text-align: center">{{ strVinograd }}</th>
                <th style="text-align: center">Datum berbe</th>
                <th style="text-align: center">Količina</th>
                <th style="text-align: center">Cena</th>
                <th style="text-align: center">Vrednost</th>
                <th></th>
              </tr>
              <tr
                v-for="(item, index) in props.item.vineyardGrapeSellingItems"
                :key="index"
              >
                <td style="text-align: center; padding: 5px">
                  {{ item.vineyardGrapeVariety.grapeVariety.name }}
                </td>
                <td style="text-align: center; padding: 5px">
                  {{ item.vineyardGrapeVariety.vineyard.name }}
                </td>
                <!-- <td>{{ formatDateTime(item.bottlingOrProductionDate) }}</td> -->
                <td style="text-align: center; padding: 5px">
                  {{
                    formatDateTime(
                      item.vineyardOperationHarvest.vineyardOperationExecution
                        .date
                    )
                  }}
                </td>
                <td style="text-align: center; padding: 5px">
                  {{ item.quantity }} {{ item.unitOfMeasure.mark }}
                </td>
                <td style="text-align: center; padding: 5px">
                  {{ Math.round(item.grapePrice * 100) / 100 }} RSD/{{
                    item.unitOfMeasure.mark
                  }}
                </td>
                <td style="text-align: center; padding: 5px">
                  {{
                    currencyFormatDE(
                      Math.round(item.grapePrice * item.quantity * 100) / 100
                    )
                  }}
                  RSD
                </td>
              </tr>
            </table>
          </template>
          <template slot="no-data">
            <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            <v-alert slot="no-results" :value="true" color="primary" icon="info"
              >Nema podataka.</v-alert
            >
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning"
            >Trazili ste "{{ search }}" ali nema rezultata.</v-alert
          >
        </v-data-table>
      </v-flex>
    </v-layout>
    <TokenComponent ref="frmtoken" />
  </div>
</template>


<script>
import { serverBus } from "../main";
import {
  readJSON,
  scrollToTopBasNaVrh,
  daLiJeVinarija,
} from "../helpers/Functions";

import TokenComponent from "../components/Token";
import { alternativeColor } from "@amcharts/amcharts5/.internal/core/util/Utils";

export default {
  name: "VineyardSellingTable",
  props: {
    msg: String,
  },
  components: {
    TokenComponent,
  },
  data: () => ({
    pagination: {
      sortBy: "date",
      rowsPerPage: 10000000,
    },
    search: "",
    headers: [
      // {
      // 	text: "ID",
      // 	align: "left",
      // 	sortable: true,
      // 	value: "id"
      // },
      { text: "", align: "left", sortable: false },
      { text: "Datum", value: "date", align: "left" },
      { text: "Kupac", value: "company.name", align: "left" },
      { text: "Vrednost", value: "vrednost", align: "right", sortable: false },
      { text: "Opis", value: "description", align: "left" },
      { text: "Funkcije", value: "funkcije", sortable: false },
    ],
    items: [],
    editedIndex: -1,
    editedItem: {
      id: 0,
      name: "",
      description: "",
    },
    defaultItem: {
      id: 0,
      name: "",
      description: "",
    },
    items_modal: [],
    vinarija: true,
    strSorta: "",
    strVinograd: "",
  }),
  methods: {
    formatDateTime(date) {
      if (date !== undefined && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join("."); // + " " + [HH, mm].join(":");
      } else return "";
    },
    currencyFormatDE(num) {
      return num
        .toFixed(2) // always two decimal digits
        .replace(".", ",") // replace decimal point character with ,
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
    },
    numberFormatDE(num) {
      return num
        .toFixed(0) // always two decimal digits
        .replace(".", ",") // replace decimal point character with ,
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
    },
    odrediVrednost(items) {
      let iznos = 0;

      items.forEach(function (entry) {
        iznos = iznos + entry.grapePrice * entry.quantity;
      });

      return this.numberFormatDE(iznos);
    },
    deleteSifarnik(id) {
      this.$http
        .delete(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_grape_selling/delete/" +
            id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // // console.log(response);

          this.getAllSifarnik();

          serverBus.$emit("applied_selling_deleting");
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .delete(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_grape_selling/delete/" +
                        id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // // console.log(response);

                      this.getAllSifarnik();

                      serverBus.$emit("applied_selling_deleting");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSifarnik() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_grape_selling/all",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_grape_selling/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSort(column) {
      if (column !== "funkcije" && column !== "vrednost")
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);

      scrollToTopBasNaVrh();

      serverBus.$emit("applied_selling", item);
    },
    otvoriDialog(item) {
      //scrollToTop(300);

      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);

      serverBus.$emit("otvori_modal", item);
    },

    deleteItem(item) {
      const index = this.items.indexOf(item);
      confirm("Da li ste sigurni da želite obrisati izabrani zapis?") &&
        this.deleteSifarnik(item.id);
    },

    brisanje(propsItem, item) {
      if (propsItem.vineyardGrapeSellingItems.length > 1) {
        this.items_modal = propsItem.vineyardGrapeSellingItems;

        let index;
        index = this.items_modal.findIndex((x) => x.id === item.id);

        if (index !== -1) this.items_modal.splice(index, index + 1);

        this.changeSifarnik(
          propsItem.id,
          propsItem.company.id,
          propsItem.description,
          propsItem.date
        );
      } else
        alert(
          "Nije moguće obrisati izabrani zapis, prodaja mora imati izabranu barem jednu stavku."
        );
    },
    changeSifarnik(id, idCompany, opis, datum) {
      var complexObject = {
        id: id,
        company: {
          id: idCompany,
        },
        date: datum,
        description: opis,
        vineyardGrapeSellingItems: this.items_modal,
      };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_grape_selling/update",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.items_modal = [];
          serverBus.$emit("applied_selling_deleting");
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/currency/update/" +
                        this.ID,
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_modal = [];
                      serverBus.$emit("applied_selling_deleting");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
  },
  mounted() {
    serverBus.$off("refresh_selling");

    serverBus.$on("vy_selling", () => {
      this.getAllSifarnik();
    });

    serverBus.$on("refresh_selling", () => {
      this.getAllSifarnik();
    });
  },
  beforeMount() {
    this.vinarija = daLiJeVinarija(localStorage.getItem("isWinery"));

    if (this.vinarija) {
      this.strSorta = "Sorta grožđa";
      this.strVinograd = "Vinograd";
    } else {
      this.strSorta = "Sorta ploda";
      this.strVinograd = "Zasad";
    }
  },
};
</script>
<style scoped lang='scss'>
@import "./parts/../../assets/sass/parts/modalStyles_siri_modal";

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

div.layout.row.wrap {
  padding-top: 20px !important;
  max-height: 90px !important;
}

.topics tr {
  line-height: 14px;
}

.topics {
  margin-left: 10%;
  border-collapse: collapse;
  border-spacing: 0;
  width: 90%;
}

.topics th {
  height: 25px;
  font-weight: 500;
  font-size: 12px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.topics td {
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

.menuable__content__active {
  background-color: white;
}
</style>